export default __webpack_public_path__ + "static/media/havilla_laptop.5f3f5b34.png";